export * from './lib/pipes/capitalize-first.pipe';
